<div class="modal-header" *ngIf="showAsDialog" ngxModalDraggable>
    <h4 class="modal-title">Order Detail</h4>
</div>
<div class="modal-body p-0 flex-fill d-flex flex-column compact-form" *ngIf="!!buildAssembly">
    <div class="card">
        <div class="card-body pb-3">
            <div class="btn-toolbar mx-0 mb-0 mt-0">
                <div>
                    <button *ngIf="hasChanges() && !showAsDialog" class="btn btn-sm btn-primary me-2" (click)="save()">Save</button>
                    <button *ngIf="hasChanges() && !showAsDialog" class="btn btn-sm btn-success me-4" (click)="cancel()">Cancel</button>
                    <button *ngIf="!hasChanges() && !showAsDialog" class="btn btn-sm btn-primary me-4" (click)="close()">Close</button>

                    <!-- <button
                        *ngIf="!hasChanges()"
                        class="btn btn-sm btn-success me-4"
                        (click)="print()"
                        [hidden]="(order.statusId !== 2 && order.statusId !== 6) || showAsDialog"
                    >
                        Print Sales Order
                    </button> -->
                </div>
                <div class="ms-auto d-flex align-items-center">
                    <ng-container>
                        <label class="mt-2 me-2">Create Date</label>
                        <dx-date-box class="me-3" [(value)]="buildAssembly.createDate" width="125px" readOnly="true"></dx-date-box>
                    </ng-container>

                    <label class="dx-box-item-content d-inline-block align-middle ms-4 me-2 mt-1">Status </label>
                    <h3>
                        <strong>{{ buildAssembly.status.name }}</strong>
                    </h3>
                    <button class="btn btn-sm btn-primary ms-3" (click)="submit()" [hidden]="(buildAssembly.statusId !== 1 && buildAssembly.statusId !== 6) || showAsDialog">
                        Submit
                    </button>
                </div>
            </div>

            <dx-form [formData]="buildAssembly" [colCount]="12" validationGroup="mainValidationGroup">
                <dxi-item itemType="group" [colSpan]="3" [colCount]="1">
                    <dxi-item dataField="buildDate" [label]="{ text: 'Built' }" [editorOptions]="{ readOnly: readOnly }"> </dxi-item>
                    <dxi-item dataField="createdBy" [label]="{ text: 'Created By' }" [editorOptions]="{ readOnly: true }"> </dxi-item>
                </dxi-item>

                <dxi-item itemType="group" [colSpan]="3">
                    <dxi-item [label]="{ text: 'Create PO' }" >
                        <div *dxTemplate>
                            <dx-check-box [(value)]="buildAssembly.createPO"  [editorOptions]="{ readOnly: true }" ></dx-check-box>
                        </div>
                    </dxi-item>

                    <dxi-item [label]="{ text: 'Vendor' }">
                        <div *dxTemplate>
                            <dx-select-box
                                [(value)]="buildAssembly.vendorId"
                                [items]="vendors"
                                valueExpr="id"
                                displayExpr="companyName"
                                searchEnabled="true"
                                searchMode="startswith"
                                [disabled]="!buildAssembly.createPO || readOnly"
                            ></dx-select-box>
                        </div>
                    </dxi-item>
                </dxi-item>

                <dxi-item itemType="group" [colSpan]="6">
                    <dxi-item [label]="{ text: 'Notes' }">
                        <div *dxTemplate>
                            <dx-text-area [(value)]="buildAssembly.notes" [height]="100"></dx-text-area>
                        </div>
                    </dxi-item>
                </dxi-item>
            </dx-form>
        </div>
    </div>

    <div class="m-1 grid-fill" [ngStyle]="{ height: showAsDialog ? '400px' : '100%' }">
        <dx-data-grid
            #linesGrid
            height="200"
            keyExpr="id"
            [dataSource]="details"
            [columnAutoWidth]="false"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onSelectionChanged)="selectionChange($event)"
            (onRowUpdated)="onRowUpdating($event)"
            (onRowDblClick)="onRowDoubleClick($event)"
            class="lines-grid"
            [sorting]="'none'"
        >
            <dxi-column dataField="lineNumber" [visible]="false" width="100" [sortIndex]="0" [sortOrder]="'asc'"></dxi-column>
            <dxi-column dataField="quantity" [editorOptions]="{ step: 0 }" caption="Qty" [allowEditing]="!readOnly" width="65"></dxi-column>
            <dxi-column dataField="partNumber" caption="Part #" [allowEditing]="false" width="200" cellTemplate="linkTemplate"></dxi-column>
            <dxi-column dataField="description" caption="Description" [allowEditing]="false" width="400"></dxi-column>
            <dxi-column dataField="builtBy" caption="Built By" [allowEditing]="true" width="200"></dxi-column>
            <dxi-column dataField="notes" caption="Note" width="150" [allowEditing]="true"></dxi-column>
            <dxi-column></dxi-column>

            <div *dxTemplate="let cell of 'linkTemplate'">
                <div class="parent-part-number" *ngIf="cell.data.partId && !cell.data.parentLineId && !cell.data.isReplacement">{{ cell.text }}</div>
                <div class="replacement-part-number" *ngIf="cell.data.isReplacement">{{ cell.text }}</div>
                <div class="misc-part-number" *ngIf="!cell.data.partId && !cell.data.isReplacement">{{ cell.text }}</div>
                <div class="option-part-number" *ngIf="cell.data.parentLineId">{{ cell.text }}</div>
            </div>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button accesskey="t" class="btn btn-sm btn-secondary me-2" (click)="addLines()" [disabled]="readOnly">Add Part(s)</button>
                <button class="btn btn-sm btn-secondary me-2" (click)="removeOrderLine()" [disabled]="readOnly || linesGrid.instance.getSelectedRowsData().length === 0">
                    Remove
                </button>
            </div>
            <dxo-selection mode="multiple"></dxo-selection>
            <dxo-editing [mode]="'cell'" [allowUpdating]="!readOnly && !showAsDialog"></dxo-editing>
            <dxo-state-storing [enabled]="true" [storageKey]="'build-assembly-detail-grid'"></dxo-state-storing>
        </dx-data-grid>
    </div>
</div>
<div class="modal-footer" *ngIf="showAsDialog">
    <button type="button" (click)="closeDialog()" class="btn btn-success ms-1">Close</button>
</div>
